import React, { useContext, useEffect } from "react";
import { useHistory, useParams } from "react-router";
import { API } from "aws-amplify";
import { Spinner } from "components";
import { AUTH_COOKIE_DOMAIN } from "aws-exports";
import Axios from "axios";
import { API_GATEWAY_NEW, APP_DEV } from "aws-exports";
import ShopContext from "context/ShopContext";

export default function ReferralScreen (props) {
  const history = useHistory();
  const { code } = useParams();
  const { AppLocalStorage } = useContext(ShopContext)
  const addDays = (date, days) => {
    const copy = new Date(Number(date));
    copy.setDate(date.getDate() + days);
    return copy.getTime();
  };
  const handleReferral = async () => {
    if (window.location.host.indexOf("monsterupsells.com") != -1) {
      AppLocalStorage.setItem(
        "aff_code",
        JSON.stringify({
          code,
          expiry: addDays(new Date(), 30)
        })
      );
      window.location.href = `https://${AUTH_COOKIE_DOMAIN}/ref/${code}`;
    } else {
      if (code) {
        const { exists } = await Axios.post(`${API_GATEWAY_NEW}/aff/events`, {
          aff_code: code,
          event: "view"
        });
        // if(exists){
        AppLocalStorage.setItem(
          "aff_code",
          JSON.stringify({
            code,
            expiry: addDays(new Date(), 30)
          })
        );
        // }
      }
      window.location.href = APP_DEV
        ? "https://localhost/login"
        : "https://apps.shopify.com/monster-upsells";
    }
  };

  useEffect(() => {
    handleReferral();
  }, []);

  // return <div onClick={handleReferral}> clivk me </div>
  return <Spinner text="Please Wait" />;
}
